module.exports = __webpack_public_path__ + "static/media/fire7.053df3bb.svg";